import {createSelector} from '@ngrx/store';

import {CORRECTION_INVOICES_FEATURE_KEY, selectInvoicesModuleState} from '../reducers';

export const selectCorrectionInvoicesState = createSelector(
  selectInvoicesModuleState,
  (state) => state[CORRECTION_INVOICES_FEATURE_KEY]
);

export const selectCorrectionInvoicesEntities = createSelector(
  selectCorrectionInvoicesState,
  (state) => state.entities
);
export const selectDetailedCorrectionInvoicesEntities = createSelector(
  selectCorrectionInvoicesState,
  (state) => state.detailedEntities
);

export const selectCorrectionInvoices = createSelector(
  selectCorrectionInvoicesEntities,
  (customers) => Object.keys(customers).map(iri => customers[iri])
);

export const selectCorrectionInvoiceByIndex = createSelector(
  selectDetailedCorrectionInvoicesEntities,
  (customers, props) => customers[props.iri]
);

export const selectCurrentCorrectionInvoice = createSelector(
  selectCorrectionInvoicesState,
  (state) => state.current
);

/////////////////////////////////////////////////////////////////////////////////////////////////////////////// Search

export const selectSearchResultsIris = createSelector(
  selectCorrectionInvoicesState,
  state => state.searchEntities
);

export const selectSearchResults = createSelector(
  selectCorrectionInvoicesEntities,
  selectSearchResultsIris,
  (entities, selection) => selection.map(key => entities[key])
);

//////////////////////////////////////////////////////////////////////////////////////////////////////////// Pagination

export const selectTotalItems = createSelector(
  selectCorrectionInvoicesState,
  state => state.totalItems
);
export const selectCorrectionInvoicePagination = createSelector(
  selectCorrectionInvoicesState,
  (state) => state.pagination
);
export const selectPaginationCurrentLink = createSelector(
  selectCorrectionInvoicePagination,
  pagination => pagination.current
);
export const selectPaginationFirstLink = createSelector(
  selectCorrectionInvoicePagination,
  pagination => pagination.first
);
export const selectPaginationPreviousLink = createSelector(
  selectCorrectionInvoicePagination,
  pagination => pagination.previous
);
export const selectPaginationNextLink = createSelector(
  selectCorrectionInvoicePagination,
  pagination => pagination?.next
);
export const selectPaginationLastLink = createSelector(
  selectCorrectionInvoicePagination,
  pagination => pagination.last
);

//////////////////////////////////////////////////////////////////////////////////////////////////////// Loading States

export const isLoading = createSelector(
  selectCorrectionInvoicesState,
  state => state.loading
);

export const isLoaded = createSelector(
  selectCorrectionInvoicesState,
  state => state.loaded
);

//////////////////////////////////////////////////////////////////////////////////////////////////////////////// Errors

export const selectErrors = createSelector(
  selectCorrectionInvoicesState,
  (state) => state.errors
);
